import styled from "styled-components";
import { ResultsMenu } from "../../../../components/FindUser/FindUser";


export const UsernameResultsWrapper = styled(ResultsMenu)`
  position: fixed !important;
  z-index: 1000;
  box-shadow: 1px 1px 1px 1px lightgray;
`